export default "__VITE_ASSET__7CrXdphg__"